import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useGroupState() {
  return useAppState();
}

export function useGroupActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      groups: [],
      lastPageViewed: 0,
      canViewMoreGroups: true,
      groupModalIsOpen: false,
      groupForm: {
        name: '',
        description: '',
        image: null,
        imageFileName: null,
      },
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function loadMoreGroupsOnResponse(response) {
    dispatch((appState) => ({
      ...appState,
      ...response,
      loading: false,
      groups: [...(appState.groups || []), ...(response.groups || [])],
      lastPageViewed: response.pageNumber ?? appState.lastPageViewed,
    }));
  }

  function openGroupModal() {
    dispatch((appState) => ({
      ...appState,
      groupModalIsOpen: true,
      groupForm: {
        name: '',
        description: '',
        image: null,
        imageFileName: null,
      },
    }));
  }

  function closeGroupModal() {
    dispatch((appState) => ({
      ...appState,
      groupModalIsOpen: false,
      groupForm: {
        name: '',
        description: '',
        image: null,
        imageFileName: null,
      },
    }));
  }

  function updateGroupFormName(name) {
    dispatch((appState) => ({
      ...appState,
      groupForm: {
        ...appState.groupForm,
        name: name,
      },
    }));
  }

  function updateGroupFormDescription(description) {
    dispatch((appState) => ({
      ...appState,
      groupForm: {
        ...appState.groupForm,
        description: description,
      },
    }));
  }

  function updateGroupFormImage(image, imageFileName) {
    dispatch((appState) => ({
      ...appState,
      groupForm: {
        ...appState.groupForm,
        image: image,
        imageFileName: imageFileName,
      },
    }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    loadMoreGroupsOnResponse,
    openGroupModal,
    closeGroupModal,
    updateGroupFormName,
    updateGroupFormDescription,
    updateGroupFormImage,
    getFeedbackFromLocalStorage,
    clearFeedback,
  };
}
